import { post, get } from '@/axios/method';

/**
 * 提交登记表单
 * 易聪林 http://yapi.dev.anoah.com/project/1223/interface/api/57788
 * @param {*} data 
 * @returns 
 */
export const submitForm = (data) => post('/api/dm/clue/form/yxSchool', data);

// 获取年级字典(李建)
export const getGradeDict = (data) => get('/api/dm/scrm/customerProfile/getClueConfigGradeMap', data);
